import { StaticToggleService } from 'util/services';
import { OneOrMany } from 'util/domain';
import { 
    PhoenixToggleService,
	ActionService,
	ProgressService,
	UploadService,
	EnvironmentService,
	AuthService
} from 'phoenix/services';
import {
	PermissionType,
	RightsType,
	pxItemTypeGuards as TypeGuards,
	ShareBaseFolder,
	ShareBaseDocument,
	ShareBaseItem,
	ShareBaseLibrary,
	UploadException
} from 'phoenix/domain';
import {
	IShareableStore,
	MenuPriority,
	MenuItemContext,
	ViewType
} from 'sharebase/domain';
import {
	ShareDialogTabs,
	ShareTab
} from 'sharebase/components/shareDialog/shareDialog';
import { ShareAction } from 'sharebase/components/shareDialog/shareDialog.actions';
import { 
	DeleteDialogController, 
	template as deleteDialogTemplateUrl  
} from 'sharebase/components/deleteDialog/deleteDialog';
import { PromptDialog } from 'sharebase/components/promptDialog/promptDialog';
import {
	ActionRepository,
	ContextMenuService,
	ToastService,
	MediaService,
	DesktopError,
	DesktopException,
	IDesktopService,
} from 'sharebase/services';
import { LibraryDataStore } from 'sharebase-app/dataStores/libraryDataStore';
import { AclDatastore } from 'sharebase/dataStores/aclDatastore';
import { FolderDataStore } from 'sharebase-app/dataStores/folderDataStore';
import { DocumentDataStore } from 'sharebase-app/dataStores/documentDataStore';
import { SelectionDataStore } from 'sharebase-app/dataStores/selectionDataStore';
import { ToolbarService } from 'sharebase-app/services/appToolBarService';
import { AppAction } from '../_app/app.actions';
import { FolderAction } from './folderView.actions';
import { FavoritesDataStore } from 'sharebase-app/dataStores/favoritesDataStore';
import { DownloadDataStore } from 'sharebase-app/dataStores/downloadDataStore';
import { RenameDialog } from 'sharebase-app/components/renameDialog/renameDialog';
import { 
	CreateFolderDialogController,
	template as createFolderDialogTemplate 
} from 'sharebase-app/components/createFolderDialog/createFolderDialog';
import { CreateTaskDialog } from 'sharebase-app/components/create-task-dialog/create-task-dialog';
import { MoveItemDialogController } from 'sharebase-app/components/moveItemDialog/moveItemDialog';
import { IShareDialogService } from 'sharebase-app/services/shareDialogService';
import { SelectableItem } from 'sharebase/components';

require('./folderView.styles');
const template = require('./folderView.template');

/**
 * @ngdoc directive
 * @name sharebase-app.directive:sbaFolderView
 * @module sharebase-app
 * @restrict E
 * @description
 *
 * `sbaFolderView` displays content of a specific folder/library
 *
 * @usage
 *
 * <sba-folder-view folder-id="1234" item-index="0" /> 
 * 
 * @element input
 * @param {integer=} folderId The id of the folder contents to display
 * 
 * @element input
 * @param {integer=} initialIndex The index of the folder item to be displayed at the top
 */
export function FolderViewDirective(
) {
	return {
		restrict: 'E',
		controller: FolderViewController,
		controllerAs: 'folderCtrl',
		template,
		bindToController: true,
		scope: {
			libraryId: '@',
			folderId: '@',
			itemIndex: '@'
		},
		link: function (scope, element, attrs) {
			var vm = scope.folderCtrl;
			scope.$watch('folderCtrl.itemIndex', function(newVal, oldVal){
				if(!newVal){return;}
				element.attr('item-index', vm.itemIndex);
			});

			// upload new document change handler
			function uploadDocumentHandler(e) {
				vm.uploadNewDocument(e.target);
			}
			var fileInput = document.getElementById('uploadDocument');
			fileInput.addEventListener('change', uploadDocumentHandler);

			scope.$on('$destroy', function(){
				vm.subscriptions.forEach(function(unsubscribe){
					unsubscribe();
				});

				vm.sbaToolbarService.hideSortOptions = false;		
					
				fileInput.removeEventListener('change', uploadDocumentHandler);

				vm.sbaLibraryDataStore.clearStore();
				vm.sbaFolderDataStore.clearStore();
				vm.sbaFavoritesDataStore.clearStore();
				vm.sbaRecentDocumentsDataStore.clearStore();

			});
		}
	};
}

FolderViewDirective.$inject =  [
];

function FolderViewController(
	$q:ng.IQService, 
	$state:ng.ui.IStateService, 
	$mdDialog:ng.material.IDialogService, 
    $timeout:ng.ITimeoutService,  
	$stateParams:ng.ui.IStateParamsService,
    pxPhoenixToggleService:PhoenixToggleService,
	staticToggleService:StaticToggleService,
	pxAuthService:AuthService, 
	pxActionService:ActionService, 
	pxEnvironmentService:EnvironmentService, 
	pxProgressService:ProgressService, 
	pxDisplayMessageService, 
	pxUploadService:UploadService, 
	sbAclDatastore:AclDatastore, 
	sbToastService:ToastService,
	sbContextMenuService: ContextMenuService,
	sbActionRepository:ActionRepository,
	sbDesktopService:IDesktopService, 
	sbMediaService:MediaService, 
	sbPromptDialog:PromptDialog,
	sbaShareDialogService:IShareDialogService, 
	sbaToolbarService:ToolbarService, 
	sbaLibraryDataStore:LibraryDataStore, 
	sbaFolderDataStore:FolderDataStore, 
	sbaRecentDocumentsDataStore, 
	sbaFavoritesDataStore:FavoritesDataStore, 
	sbaSelectionDataStore: SelectionDataStore, 
	sbaDocumentDataStore:DocumentDataStore,
	sbaInProgressItemsDataStore, 
	sbaDownloadDataStore:DownloadDataStore,
	sbaRenameDialog:RenameDialog,
	sbaCreateTaskDialog:CreateTaskDialog,
	sbaMoveItemDialog: MoveItemDialogController,
	SB_CHAR_LIMIT:number,
	SBA_GET_REQUEST_RIGHTS_ENABLED:() => boolean,
	gettextCatalog:ng.gettext.gettextCatalog
) {
	let vm = this;
	let currentUserAcl;
	vm.useDataUri = staticToggleService.isEnabled('data-uri-images');
	vm.showThumbnails = true; 
	vm.targetItem;
	vm.loading = false;
	vm.isUploadOnly = false;
	vm.initialIndex = 0;
	vm.sbaLibraryDataStore = sbaLibraryDataStore;
	vm.sbaFavoritesDataStore = sbaFavoritesDataStore;
	vm.sbaFolderDataStore = sbaFolderDataStore;
	vm.sbaRecentDocumentsDataStore = sbaRecentDocumentsDataStore;
	vm.sbaToolbarService = sbaToolbarService;
	vm.selectionDS = sbaSelectionDataStore;
	vm.EnvironmentService = pxEnvironmentService;
	vm.pxAuthService = pxAuthService;
	vm.pxActionService = pxActionService;
	vm.itemClicked = itemClicked;
	vm.doneLoading = doneLoading;
	vm.setItemSelect = setItemSelect;
	vm.toggleItemSelect = toggleItemSelect;
	vm.showContextMenu = showContextMenu;
	vm.showVirtualContextMenu = showVirtualContextMenu;
	vm.subscriptions = [];
	vm.selectedItem = null;
	vm.selectedItems = [];
	vm.selectAll = false;		
	vm.inProgressDS = sbaInProgressItemsDataStore;
	vm.deleteItem = deleteItem;
	vm.uploadNewDocument = uploadNewDocument;
	vm.media = sbMediaService;
	vm.favoriteItem = favoriteItem;
	vm.unfavoriteItem = unfavoriteItem;
	vm.registeredViews =[
		{name:'list',icon:'list',label: gettextCatalog.getString('List'),remember:true},	
		{name:'card',icon:'view_module',label: gettextCatalog.getString('Tile'),remember:true}
	];
	vm.uploadErrorCallback = uploadErrorCallback;
		
	Object.defineProperties(vm, {
		canEdit: {
			get: () => {
				return currentUserAcl ? currentUserAcl.hasPermission(PermissionType.MODIFY) : false;
			}
		},
		canUpload: {
			get: () => {
				return currentUserAcl ? currentUserAcl.hasPermission(PermissionType.ADDDOC) : false;
			}
		}
	});

	vm.createFolder = (e: ng.IAngularEvent) => {
		if(vm.canEdit){
			pxActionService.emit({
				type: FolderAction.CreateFolder,
				payload: vm.targetItem
			}, e);
		}			
	};

	vm.addDocument = addDocument;
	vm.libraryEmptyMessage = pxEnvironmentService.touchEnabled ?
		gettextCatalog.getString('Tap to create folder') :
		gettextCatalog.getString('Click to create folder');

	vm.folderEmptyHeader = vm.isUploadOnly ?
		gettextCatalog.getString('This folder is shared for uploads') :
		gettextCatalog.getString('This folder is empty');

	function itemClicked($event, item) {
		if (item.inProgress) {
			return;
		}
		if(vm.selectionDS.isInSelectionMode){
			toggleItemSelect(item);
			return;
		}
		
		if(!item.DocumentId || !currentUserAcl || !currentUserAcl.hasRight(RightsType.UPLOADONLY)){
			openItem(item);
		} else {
			sbToastService.showSimple(gettextCatalog.getString('You do not have rights to access this document.'));	
		}
	}

	function openItem(item:ShareBaseItem){	
		const sharedContent = !pxAuthService.isShareByLinkUser && sbaLibraryDataStore.myLibrary && sbaLibraryDataStore.myLibrary.LibraryId !== item.LibraryId;	
		
		// this is the current user's top-level library
		if(!sharedContent && TypeGuards.isShareBaseLibrary(item)){
			return $state.go('content.myFiles.home');
		}

		let state = '';
		let params:any = {};
		let context = 'content.myFiles';

		// If we're currently in the content.shared context, remain there.  
		// If we're not a share by link user, the file we are opening is not in My Files library
		// and so use the 'content.shared' context.
		if(sharedContent || $state.current.name.indexOf('content.shared') > -1){
			context = 'content.shared';
		}

		if (TypeGuards.isShareBaseFolder(item)) {
			state = `${context}.folder`;
			params = { 
				folderID: item.FolderId
			};
		} 
		else if (TypeGuards.isShareBaseDocument(item)){
			state = `${context}.document`;
			params = { 
				docID: item.DocumentId 
			};
		}
		else if(TypeGuards.isShareBaseLibrary(item)){
			state = `${context}.library`;
			params = {
				libraryID : item.LibraryId
			}
		}

		// If share by link user, make sure the user goes to
		// the share route and the token remains on the url
		if (pxAuthService.isShareByLinkUser) {
			state += '.share';
			params.token = $stateParams.token;
			params.password = $stateParams.password;
			params.recipient = $stateParams.recipient;
		}

		$state.go(state, params);
	}

	function selectItemOnTouchEnabled(item){
		if (pxEnvironmentService.touchEnabled){
			setItemSelect(item);
		}
	}

	function setItemSelect(item){
		item.selected = true;
		vm.selectionDS.setItemSelect(item);
	}
	function toggleItemSelect(item){			
		item.selected = !item.selected;
		vm.selectionDS.setItemSelect(item);
	}

	function setFolderData() {
		vm.sbaToolbarService.hideSortOptions = false;
		setLoading();
		let p:ng.IPromise<any> = $q.resolve();
		let itemType;
		let primeAclCache:ng.IPromise<void>;

		if (!vm.folderId && !vm.libraryId) {
			// user library
			itemType = 'library';
			p = sbaLibraryDataStore
				.loadLibrary()
				.then(() => {
					vm.targetItem = sbaLibraryDataStore.library;
					vm.sbaToolbarService.title = gettextCatalog.getString('My Files');						
					return sbaLibraryDataStore.getCurrentUserAcl();
				})
				.then(acl => {						
					currentUserAcl = acl;
				});
		}
		else if (vm.libraryId) {
			// library
			itemType = 'library';
			p = sbaLibraryDataStore
				.loadLibrary(vm.libraryId)
				.then(library => {
					vm.targetItem = sbaLibraryDataStore.library;
					vm.sbaToolbarService.title = library.LibraryName;						
					return sbaLibraryDataStore.getCurrentUserAcl();						
				})
				.then(acl => {
					currentUserAcl = acl;
				});
		}
		else if (vm.folderId === 'recents') {
			vm.sbaToolbarService.hideSortOptions = true;
			vm.sbaToolbarService.title = gettextCatalog.getString('Recently Viewed');
			p = sbaRecentDocumentsDataStore
				.load()
				.then(recents => {
					vm.targetItem = recents;
				});
		}
		else if (vm.folderId === 'favorites') {
			vm.sbaToolbarService.title = gettextCatalog.getString('Favorites');
			p = sbaFavoritesDataStore
				.load()
				.then(favorites => {
					vm.targetItem = favorites;
				});
		}
		else {
			let folderCalls: ng.IPromise<any>[] = [];
			itemType = 'folder';
			p = sbaFolderDataStore
				.load(vm.folderId, true, true)
				.then(function (folder) {
					vm.targetItem = folder;
					vm.sbaToolbarService.title = folder.FolderName;						
					
					folderCalls.push(sbaFolderDataStore
						.getCurrentUserAcl()
						.then(acl => {
							currentUserAcl = acl;
							vm.isUploadOnly = acl.hasRight(RightsType.UPLOADONLY) && !acl.hasPermission(PermissionType.LISTFOLD);
							vm.showThumbnails = acl.hasPermission(PermissionType.READDOC);
						})
					);

					if(!pxAuthService.isShareByLinkUser){
						folderCalls.push(
							sbaFolderDataStore.getShares(),
							sbaFolderDataStore.getLinks()
						);
					}
					
					return $q.all(folderCalls);
				});
		}

		return p
			.then(() => {
				registerMenuItems();
				addScanAction(vm.targetItem);
				sbaToolbarService.actionTarget = vm.targetItem;
				
				//TODO - create a function to determine other smart views
				return setPlaylistView();
			})
			.catch(e => {
				let header = gettextCatalog.getString('Content can\'t be viewed.');
				let msg = '';
				let msgData = {
					itemType
				};

				if(itemType){
					switch (e.status) {				
						case 400:
							msg = gettextCatalog.getString('This {{itemType}} couldn\'t be found.', msgData);
							break;
						case 403:
							msg = gettextCatalog.getString('You do not have rights to access this {{itemType}}.', msgData);
							break;
						case 404:
							msg = gettextCatalog.getString('This {{itemType}} has been deleted.', msgData);
							break;
						case 409:
							header = gettextCatalog.getString('This {{itemType}} is not ready to be viewed.', msgData);
							msg = gettextCatalog.getString('Please try again later.');
							break;
						default:
							msg = gettextCatalog.getString('An error occurred accessing this {{itemType}}.', msgData);
							console.error(e);
							break;
					}
				}

				pxDisplayMessageService.display(header, msg);
			})
			.finally(setInitialIndex);
	}

	function setPlaylistView(){		
		return pxPhoenixToggleService.isEnabled('Core/Smart-Views')
			.then(enabled=> {
				if(!enabled || sbaFolderDataStore.folders.length > 0){
					return;
				}

				// not just content
				let isMedia;
				let playlistView:ViewType = {
					name:'playlist',
					icon:'playlist_play',
					label: gettextCatalog.getString('Playlist'),
					remember:false
				};
				let mediaContent = sbaFolderDataStore.documents.filter(c=> c.FileFormat === 'Audio File' || c.FileFormat === 'Video');
	
				if(mediaContent.length > 0 &&  mediaContent.length === sbaFolderDataStore.documents.length){
					// everything is media so add the playlist view
					registerAdditionalVew(playlistView);
					isMedia = true;
				}				
		
				if(isMedia && !vm.canEdit){
					// make playlistview the default
					sbaToolbarService.viewType = playlistView;
					sbaToolbarService.smartViewEnabled = true;
				}
			});
	}

	function registerAdditionalVew(view:ViewType){
		sbaToolbarService.addView(view);		
		vm.registeredViews.push(view);
	}

	/**
	 * Add menu items appropriate to all folder view scenarios.
	 * This should be called before the toolbar arget is set and only once.
	 **/
	function registerMenuItems(){
		vm.subscriptions.push(...sbActionRepository
			.getActions([
				FolderAction.SelectAll
			])
			.map(a => sbActionRepository.createFromAction(a))
			.map(i => sbaToolbarService.addItem(i, MenuPriority.MEDIUMLOW))
		);

		vm.subscriptions.push(sbaToolbarService
			.getItem(FolderAction.SelectAll)
			.addValidator<any>((target, all, original) => { 
				return (Array.isArray(original) && original.length > 0) || 
					TypeGuards.isShareBaseFolder(original) || 
					TypeGuards.isShareBaseLibrary(original)
			}
		));

		// we only want to perform certain actions from a folder view on a library or folder
		vm.subscriptions.push(...sbaToolbarService
			.getItems(
				AppAction.Download,
				AppAction.Move,
				AppAction.Delete,
				AppAction.Favorite,
				AppAction.Copy
			)
			.map(i => i.addValidator<any>((target, all, original) => {
				return target && 
					!Array.isArray(original) && 
					(TypeGuards.isShareBaseLibrary(original) || TypeGuards.isShareBaseFolder(original))
			}))
		);	

		sbActionRepository
			.getActions([
				FolderAction.OpenDocument, 
				FolderAction.OpenFolder
			])
			.map(action => sbActionRepository.createFromAction(action, !SBA_GET_REQUEST_RIGHTS_ENABLED()))
			.forEach(i => vm.subscriptions.push(sbContextMenuService.addItem(i)));

		sbActionRepository
			.getActions([
				FolderAction.UploadDocument,
				FolderAction.CreateFolder,
				FolderAction.CreateDocument
			])
			.map(action => sbActionRepository.createFromAction(action, !SBA_GET_REQUEST_RIGHTS_ENABLED()))			
			.forEach(i => vm.subscriptions.push(sbaToolbarService.addItem(i, MenuPriority.HIGH)));
		
		sbaToolbarService
			.getItem(FolderAction.CreateDocument)
			.addValidator(() => pxPhoenixToggleService.isEnabled('Core/InlineEdit'));
	}

	function showVirtualContextMenu(item){
		if(item.item && item.event){
			showContextMenu(item.item, item.event);
		}
	}
	function showContextMenu(item, event){
		vm.selectedItem = sbaSelectionDataStore.selectedItems.length===1 ? vm.selectedItems[0] : item;

		//load acl upfront to minimize duplicate permission request, then show context menu via service call
		sbAclDatastore.load(item)
			.then(function(){
				sbContextMenuService.open(item, event);
			});
	}

	function setInitialIndex() {
		//if the item index is set then let make sure the virtual repeat
		if (vm.folderId === 'recents' || 
				vm.sbaToolbarService.viewType !== 'card' || 
				vm.itemIndex === '0' || 
				vm.itemIndex === undefined
			) { 
			doneLoading();
			return;
		}

		var index = vm.itemIndex;
		vm.itemIndex = 0;
		$timeout(function () {
			vm.itemIndex = parseInt(index);
			doneLoading();
		}, 500);
	}
	
	function setLoading() {
		vm.loading = true;
		pxProgressService.visible = true;
	}

	function doneLoading() {
		vm.loading = false;
		pxProgressService.visible = false;
	}

	function deleteItem(item:OneOrMany<ShareBaseItem>, event) {
		let purge = false;
		let items:ShareBaseItem[] = Array.isArray(item) ? item : [item];
		$mdDialog.show({
			parent: angular.element(document.body),
			controller: DeleteDialogController,
			controllerAs: 'vm',
			template: deleteDialogTemplateUrl,
			targetEvent: event,
			locals: { item: item },
			clickOutsideToClose: false,
			bindToController: true
		})
		.then(permanentlyDelete => {				
			purge = permanentlyDelete;
			pxProgressService.visible = true;
			return $q.all(items.map(i => {
				let p = i.IsFavorite ? sbaFavoritesDataStore.removeFavorite(i) : $q.resolve();
				if (TypeGuards.isShareBaseDocument(i)) {							
					return p.then(() => {
						if (vm.folderId === 'favorites') {
							return sbaFavoritesDataStore.deleteDocument(i, purge);
						}
						else if (vm.folderId === 'recents') {
							return sbaRecentDocumentsDataStore.deleteDocument(i, purge);
						}
						else {
							return sbaFolderDataStore.deleteDocument(i, purge)
						}
					});
				}
				else if(TypeGuards.isShareBaseFolder(i)){
					return p.then(() => {
						if (vm.libraryId || $state.current.name.indexOf('myFiles.home') >= 0 ) {
							return sbaLibraryDataStore.deleteFolder(i, purge);
						}
						else if (vm.folderId === 'favorites') {
							return sbaFavoritesDataStore.deleteFolder(i, purge);
						}
						else {
							return sbaFolderDataStore.deleteFolder(i, purge);
						}
					});
				}
			}));
		})
		.then(() => {
			let message = '';
			if (items.length === 1) {
				const item = items[0];
				if(TypeGuards.isShareBaseFolder(item)){
					message =  purge ? 
						gettextCatalog.getString('The folder has been permanently deleted') :
						gettextCatalog.getString('The folder has been deleted');

					// deleting the folder we're currently in; bring user back a level
					if(item.FolderId === +vm.folderId && sbaFolderDataStore.breadcrumbs) {
						goUpDirectory();
					}
				}
				else {
					message = purge ?
						gettextCatalog.getString('The document has been permanently deleted') :
						gettextCatalog.getString('The document has been deleted');
				}
			}
			else {
				message = purge ? 
					gettextCatalog.getString('The selected items have been permanently deleted') :
					gettextCatalog.getString('The selected items have been deleted');
			}

			sbaSelectionDataStore.clearSelection();	
			sbToastService.showSimple(message);
		})
		.catch(function(res) {
			// if user cancelled, just don't do anything
			if (res.cancelled) {
				return;
			}

			let message = '';
			let itemHasFolders = items.some(TypeGuards.isShareBaseFolder);
			if (items.length === 1) {
				if (purge) {
					message = itemHasFolders ? gettextCatalog.getString('Unable to permanently delete the folder') :
						gettextCatalog.getString('Unable to permanently delete the document');
				}
				else {
					message = itemHasFolders ? gettextCatalog.getString('Unable to delete the document') :
						gettextCatalog.getString('Unable to delete the document');
				}
			}
			else {
				message = gettextCatalog.getString('Unable to delete one or more of the selected items');
			}

			sbToastService.showSimple(message);
			setFolderData();
		})
		.finally(() => {							
			pxProgressService.visible = false;
		});
	}

	function goUpDirectory(){
		const lastCrumb = sbaFolderDataStore.breadcrumbs[sbaFolderDataStore.breadcrumbs.length - 1];
		openItem(lastCrumb);
	}

	function moveItem(target, event) {
		// use the current state to determine if the folder should be moved via the library
		// data store, or the folder data store. We are assuming if the current state is 'content.myFiles.home',
		// all data is presented via the library data store, so we should use that data store to move the file
		// so the data in the UI gets updated. If the state is 'content.myFiles.folder', we are assuming the
		// data is presented using the folder data store, so we should use that to move the folder.

		sbaMoveItemDialog.open(event, target, false, setFolderData).then(function(item) {
				// setup the correct destination. If the destination is the metafolder "myFiles"
				// we are assuming the user is moving a folder, and they want to move it to the
				// root of their personal library, so set the destination as the personal library.
				var dest = item.destination.ref;

				if (dest === 'myFiles') {
					item.destination.ref = sbaLibraryDataStore.myLibrary;
				}

				// make sure the personal library has been loaded
				if (dest === 'myFiles' && !item.destination.ref) {
					return sbaLibraryDataStore.loadLibrary()
						.then(function(lib) {
							item.destination = { };
							item.destination.ref = lib;
							return item;
						});
				}

				return item;
			})
			.then(function(item) {
				var promise;
				var message = '';
				var dest = item.destination.ref;
				if (item.isCollection) {
					message = gettextCatalog.getString('Your items have been moved');
					// In order to have documents/folders update as they are moved,
					// we need to make sure we are calling move on the correct data store.
					// For documents, we pretty much always want to call it on the folder
					// data store so that we can update the documents collection as the move requests
					// complete.
					// For folders, we need to figure out if the current context is a folder view or
					// the root ("My Files") section. If it is the root, we need to move the item on
					// the library data store so we can update the the folders collection as items are
					// moved. If it is a folder view, call it on the folder data store.
					promise = [ ];

					if (item.collectionHasDocuments) {
						promise = promise.concat(sbaFolderDataStore.moveDocument(
							item.item.filter(TypeGuards.isShareBaseDocument),
							dest
						));
					}

					if (item.collectionHasFolders) {
						var moveFn = $state.current.name.indexOf('content.myFiles.home') >= 0 ?
							sbaLibraryDataStore.moveFolder.bind(sbaLibraryDataStore) :
							sbaFolderDataStore.moveFolder.bind(sbaFolderDataStore);

						promise = promise.concat(moveFn(
							item.item.filter(TypeGuards.isShareBaseFolder),
							dest
						));
					}

					vm.inProgressDS.setItems(target);
					promise = $q.all(promise);

				}
				else if (item.isDocument) {
					message = gettextCatalog.getString('Your document has been moved');
					vm.inProgressDS.setItems([target]);
					promise = sbaFolderDataStore.moveDocument(item.item, dest);
				}
				else {
					message = gettextCatalog.getString('Your folder has been moved');
					vm.inProgressDS.setItems([target]);
					promise = sbaFolderDataStore.moveFolder(item.item, dest);
				}
				return promise.then(function() {
					sbaSelectionDataStore.clearSelection();
					sbToastService.showSimpleAction(message, gettextCatalog.getString('Open'), () => openItem(dest), 3000, 'launch');
				})
				.catch(function(response) {
					if (!response) {
						// user cancelled dialog
						return;
					}
					if (response.data.StatusCode === 'ERR_DOCUMENT_ALREADY_EXISTS'){
						sbToastService.showSimple(gettextCatalog.getString(response.data.Message + ' already exists in destination.'));
					}
					else if (Array.isArray(target)) {
						sbToastService.showSimple(gettextCatalog.getString('Unable to move one or more of the selected items'));
					}
					else {
						sbToastService.showSimple(gettextCatalog.getString('Unable to move the selected item'));
					}
					sbaSelectionDataStore.clearSelection();
				})
				.finally(function() {
					sbaInProgressItemsDataStore.clear();
				});
			});
	}

	function itemRename(item:SelectableItem, $event){			
		let datastore;
		if(TypeGuards.isShareBaseFolder(item)){
			if (!vm.folderId) {
				datastore = sbaLibraryDataStore;
			}
			else if (vm.folderId === 'favorites') {
				datastore = sbaFavoritesDataStore;
			}
			else {
				datastore = sbaFolderDataStore;
			}
		}
		else if(TypeGuards.isShareBaseDocument(item)){
			if (vm.folderId === 'recents') {
				datastore = sbaRecentDocumentsDataStore;
			}
			else if (vm.folderId === 'favorites') {
				datastore = sbaFavoritesDataStore;
			}
			else {
				datastore = sbaFolderDataStore;
			}
		}

		sbaRenameDialog
			.open($event, item, datastore)
			.then(newName => {
				if (item.selected) {
					sbaSelectionDataStore.renameItem(item, newName);
				}

				if(vm.targetItem && TypeGuards.isShareBaseFolder(item)){
					// renaming a folder itself
					if(vm.targetItem === item){
						vm.sbaToolbarService.title = item.FolderName;
					}
				}
			});
	}

	function createFolder(item, event){
		$mdDialog.show({
			controller: CreateFolderDialogController,
			controllerAs: 'vm',
			template: createFolderDialogTemplate,
			parent: angular.element(document.body),
			targetEvent: event,
			bindToController: true,
			clickOutsideToClose:true,
			locals: {
				charLimit: SB_CHAR_LIMIT
			}
		})
		.then(function(creatFolderName) {
			var createFunction = item.LibraryId && !item.FolderId ? sbaLibraryDataStore.createFolder(creatFolderName) : sbaFolderDataStore.createFolder(creatFolderName);
			
			createFunction
				.catch(function(error){
					var msg = '';
					switch (error.status) {
						case 409:
							msg = gettextCatalog.getString('Unable to create.  A folder with that name already exists.');
							break;
						default:
							msg = gettextCatalog.getString('Unable to create folder');
							break;
					}
					sbToastService.showSimple(msg);
				});
		}, angular.noop);
	}

	function createDocument(e){
		let title = gettextCatalog.getString('Create Document');
		let placeholder = gettextCatalog.getString('Document name');
		sbPromptDialog
			.open(e, title, placeholder)
			.then(docName => sbaFolderDataStore.createDocument(docName))
			.then(doc => {
				$state.go('content.myFiles.document', {
					docID: doc.DocumentId
				});
			})
			.catch(e => {
				let msg = gettextCatalog.getString('Unable to create document');
				sbToastService.showSimple(msg);
			});
	}

	function downloadItems(items) {
		// if all items in the folder were selected, just download the current folder
		// instead of passing all child items to the API
		if (angular.isArray(items) && sbaFolderDataStore.allContent && items.length === sbaFolderDataStore.allContent.length) {
			items = vm.targetItem;
		}

		let context = sbaFolderDataStore.folder || sbaLibraryDataStore.library;
		let filename = generateFileName(context);
		sbaDownloadDataStore.downloadItems(items, filename);
	}

	function generateFileName(context?:ShareBaseFolder|ShareBaseLibrary){
		let filename:string;
		if (TypeGuards.isShareBaseLibrary(context)) {
            filename = context.IsPrivate ? gettextCatalog.getString('My Files') : context.LibraryName;
		} 
		else if(TypeGuards.isShareBaseFolder(context)){
            filename = context.FolderName;
		}
		else if(sbaFavoritesDataStore.favoritedItems.length > 0){
			filename = gettextCatalog.getString('Favorites');
		}
		else if(sbaRecentDocumentsDataStore.hasDocuments){
			filename = gettextCatalog.getString('Recents')
		}
		
		return filename;
	}

	function copyItem(target, event) {
		sbaMoveItemDialog.open(event, target, true, setFolderData).then(function(item) {
				var promise;
				var message;

				if (Array.isArray(item.item)) {
					message = gettextCatalog.getString('Your documents have been copied');
					promise = $q.all(sbaDocumentDataStore.copyDocument(item.item, item.destination.ref));
				}
				else {
					message = gettextCatalog.getString('{{documentName}} has been copied', { documentName: item.item.DocumentName });
					promise = sbaDocumentDataStore.copyDocument(item.item, item.destination.ref);
				}
				return promise.then(function() {
					sbaSelectionDataStore.clearSelection();
					sbToastService.showSimpleAction(message, gettextCatalog.getString('Open'), () => openItem(item.destination.ref), 3000, 'launch');
					// reload page if copying to current folder
					if (item.destination === vm.targetItem) {
						setFolderData();
					}
				})
				.catch(function(res) {
					if (!res) {
						// user cancelled, do nothing
						return;
					}

					var errMessage = Array.isArray(target) ? gettextCatalog.getString('Unable to copy the selected documents')
						: gettextCatalog.getString('Unable to copy the selected document');
					sbToastService.showSimple(errMessage);
				});
			});
	}

	function createTaskForItem(item:ShareBaseDocument, e:ng.IAngularEvent) {
		sbaCreateTaskDialog.open(e, item);
	}

	function selectAllItems(){	
		var items = [];
		if(vm.folderId === 'recents'){
			Object.keys(sbaRecentDocumentsDataStore.documents).forEach(function (key) {
				items = items.concat(sbaRecentDocumentsDataStore.documents[key]);
			});
		}
		else if (vm.folderId === 'favorites'){
			items = vm.sbaFavoritesDataStore.favoritedItems;
		}
		else{				
			items = vm.targetItem.IsLibrary ?
				sbaLibraryDataStore.folders :
				vm.sbaFolderDataStore.allContent;
		}


		sbaSelectionDataStore.selectItems(items);
	}

	function favoriteItem(items:OneOrMany<ShareBaseItem>, e:ng.IAngularEvent, context:MenuItemContext) {
		let message:string;
		if (!Array.isArray(items)) {
			if (TypeGuards.isShareBaseDocument(items)) {
				message = gettextCatalog.getString('{{documentName}} has been added to your favorites', { documentName: items.DocumentName });
			}
			else if (TypeGuards.isShareBaseFolder(items)) {
				message = gettextCatalog.getString('{{folderName}} has been added to your favorites', { folderName: items.FolderName });
			}
			items = [items];
		}
		else {				
			message = gettextCatalog.getString('The selected items have been added to your favorites');
		}

		let favoritePromises = items.map(item => sbaFavoritesDataStore.addFavorite(item));
		return $q.all(favoritePromises)
			.then(() => { 
				sbToastService.showSimple(message, 1500);	
				if(context === MenuItemContext.SelectionBar) {				
					pxActionService.emit({
						type: AppAction.RefreshSelectionBar
					});
				}
			});
	}

	function unfavoriteItem(items:OneOrMany<ShareBaseItem>, event:ng.IAngularEvent, context:MenuItemContext) {
		let message:string;
		if (!Array.isArray(items)) {
			if (TypeGuards.isShareBaseDocument(items)) {
				message = gettextCatalog.getString('{{documentName}} has been removed from your favorites', { documentName: items.DocumentName });
			}
			else if  (TypeGuards.isShareBaseFolder(items)) {
				message = gettextCatalog.getString('{{folderName}} has been removed from your favorites', { folderName: items.FolderName });
			}
			items = [items];
		}
		else {
			message = gettextCatalog.getString('The selected items have been removed from your favorites');
		}

		let saveRemovedFavorites = items.map(item => sbaFavoritesDataStore.removeFavorite(item));
		return $q.all(saveRemovedFavorites)
			.then(() => {
				sbToastService.showSimple(message, 1500);
				if(context === MenuItemContext.SelectionBar) {
					// TODO: remove this when a better strategy for dealing with the issue of selected 
					// favorites dissapearing when unfavorited in the favorties view is devised
					if($state.current.name.indexOf('content.favorites') >= 0){
						sbaSelectionDataStore.clearSelection();
					}
					
					pxActionService.emit({
						type: AppAction.RefreshSelectionBar
					});				
				}
			});
	}

	function addDocument(target, event) {
		if (vm.canUpload) {
			var fileInput = document.getElementById('uploadDocument');
			if (fileInput) {
				fileInput.click();
			}
		}
	}

	function uploadNewDocument(fileInput:HTMLInputElement) {
		let files = fileInput.files;

		let uploadCalls: ng.IPromise<any>[] = [];
		for (var i = 0; i < files.length; i++) {
			let file = files.item(i);
			uploadCalls.push(
				pxUploadService.addFile(file, vm.targetItem.FolderId, file.name, vm.targetItem.Links.DocumentsUri)
					.catch((exception:UploadException) => {
						sbToastService.showSimple(exception.userMessage);
					}));
		}

		$q.all(uploadCalls)
			.then(() => {
				setFolderData();
			})

	}

	function uploadErrorCallback(exception:UploadException){
		sbToastService.showSimple(exception.userMessage);
	}

	function scanDocument(target) {
		sbDesktopService.scan(target)
			.catch(function(err) {
				sbToastService.showSimple(scanErrorMessage(err));
			});
	}

	function scanErrorMessage(err:DesktopException) {
		switch (DesktopError[err.type]) {
			case DesktopError.PORT_SCAN_FAILED:
				return gettextCatalog.getString('Unable to connect to the desktop.');
			case DesktopError.USER_MISMATCH:
				return gettextCatalog.getString('A different user is logged into the desktop.');
			case DesktopError.NO_SCANNER:
				return gettextCatalog.getString('Could not connect to a scanner.');
			case DesktopError.NOT_AUTHENTICATED:
				return gettextCatalog.getString('You must be logged into the desktop to scan documents.');
			default:
				return gettextCatalog.getString('Unable to scan documents');
		}
	}

	function scanComplete(notifications) {
		var notification = notifications.filter(function(n) {
			return n.Command.toLowerCase() === 'scan';
		});

		if (notification.length === 0) {
			return;
		}

		notification = notification[0];
		if (notification.Embedded.FolderId === vm.targetItem.FolderId) {
			// User is still viewing the folder they scanned the document to
			setFolderData()
				.then(function() {
					sbaFolderDataStore.loadDetails();
				});
		}

		sbToastService.showSimple(gettextCatalog.getString('Your document has been uploaded'));
	}

	function sortView(sortType) {
		if (!vm.folderId) {
			// Library view
			sbaLibraryDataStore.sort(sortType);
		}
		else if (vm.folderId === 'recents') {
			// Recent documents view
			sbaRecentDocumentsDataStore.sort(sortType);
		}
		else if (vm.folderId === 'favorites') {
			// Favorites view
			sbaFavoritesDataStore.sort(sortType);
		}
		else {
			// Folder view
			sbaFolderDataStore.sort(sortType);
		}
	}

	function addScanAction(scanTarget?) {
		let p:ng.IPromise<any> = $q.resolve();
		// Only attempt to discover and add item if the user is viewing an actual folder
		if(scanTarget && !Array.isArray(scanTarget) && vm.folderId && vm.folderId !== 'recents' && !pxAuthService.isShareByLinkUser){
			// Check for scanning outside of context menu validation. This way
			// the toolbar actions do not have to wait on a potentially long operation
			// This is a stop gap for now, ideally the context menu service will be
			// able to handle this for us, but since there are already plans to refactor
			// the toolbar/context menu, I thought this is good enough for now.
			p = sbDesktopService
				.discover()
				.then(() => {
					// If the application had to actually go to the discovery process, the user
					// could have navigated through the app between the time the process started
					// and now. This has two implications:
					// 1. The user could be viewing a library, in which case, we shouldn't add the action anymore
					// 2. This callback could be registered multiple times and therefore multiple functions are trying
					//    to add the same item. We need to do some checks to mitigate this
					if (!sbaToolbarService.getItem(FolderAction.Scan)) {
						let scanItem = sbActionRepository.createFromActionName(FolderAction.Scan);							
						vm.subscriptions.push(sbaToolbarService.addItem(scanItem, MenuPriority.HIGH));

						// explicitly invoke validators since there is a chance that this item gets 
						// added some time in the future after the other toolbar items have been evaluated
						return scanItem.canShow(sbaToolbarService.actionTarget);
					}
				})
				.catch(angular.noop);
		}

		return p;
	}

	(function () {	
		//add the default folder view types
		vm.registeredViews.forEach(element => {
			sbaToolbarService.addView(element);	
		});	
		

		function viewShares(args: {tab:ShareTab, list:number}, $event: ng.IAngularEvent) {
			let {tab, list} = args;
			sbaShareDialogService.show($event, vm.targetItem as ShareBaseFolder, sbaFolderDataStore as IShareableStore, tab, list);
		}

		function share(item, $event) {
			item = item || vm.targetItem;
			prepareShare(item).then(store => {					
				sbaShareDialogService.show($event, item, store, ShareDialogTabs.UserShare.Create, 3);
			});
		}

		function shareLink(item, $event) {
			item = item || vm.targetItem;
			prepareShare(item).then(store => {
				sbaShareDialogService.show($event, item, store, ShareDialogTabs.LinkShare.Create, 0);
			});
		}

		function prepareShare(item){
			let store:IShareableStore = sbaFolderDataStore;
			let p = $q.resolve();
			if(item !== vm.targetItem) {
				let id;
				
				if (angular.isDefined(item.DocumentId)) {
					id = item.DocumentId;
					store = sbaDocumentDataStore;
				} else {
					throw new Error('Sharing other folders from folder view not currently supported.');
				}

				p = store.load(id);
			}
			
			return p.then(() => store);
		}

		//manage subscriptions
		vm.subscriptions.push(...pxActionService.subscribe([
			[AppAction.Delete, deleteItem],			
			[AppAction.Move, moveItem],
			[AppAction.Rename, itemRename],
			[AppAction.Download, downloadItems],
			[AppAction.Copy, copyItem],
			[AppAction.SortChange, sortView],
			[AppAction.CreateDocumentUserShare, share],
			[AppAction.CreateDocumentLinkShare, shareLink],
			[AppAction.CreateFolderUserShare, share],
			[AppAction.CreateFolderLinkShare, shareLink],
			[AppAction.Favorite, favoriteItem],
			[AppAction.Unfavorite, unfavoriteItem],
			[FolderAction.OpenFolder, openItem],
			[FolderAction.CreateFolder, createFolder],
			[FolderAction.CreateDocument, createDocument],
			[FolderAction.SelectAll, selectAllItems],
			[FolderAction.UploadDocument, addDocument],
			[FolderAction.Scan, scanDocument],
			[FolderAction.OpenDocument, openItem],
			[ShareAction.ViewShares, viewShares]
		]));

		vm.subscriptions.push(pxUploadService.onComplete(setFolderData));
		vm.subscriptions.push(pxUploadService.onCancel(setFolderData));
		
		pxPhoenixToggleService.isEnabled('Platform/Tasks')
			.then((enabled) => {
				if(enabled) {
					vm.subscriptions.push(pxActionService.subscribe<any>(AppAction.CreateTask, createTaskForItem));
				}
			});

		setFolderData()
			.then(() => {
				let notificationSub = sbDesktopService.startPolling().subscribe(scanComplete);					
				vm.subscriptions.push(() => {
					notificationSub();
					sbDesktopService.stopPolling();
				});
				vm.folderEmptyMessage = gettextCatalog.getString('You must have access to add content');
				if(vm.canUpload) {
					vm.folderEmptyMessage = pxEnvironmentService.touchEnabled ?
						gettextCatalog.getString('Tap to add content') :
						gettextCatalog.getString('Click to add content or drag and drop files');
				}
			});
	})();
}

FolderViewController.$inject = [
	'$q',
	'$state',
	'$mdDialog',
    '$timeout',
	'$stateParams',
    'pxPhoenixToggleService',
	'staticToggleService',
	'pxAuthService',
	'pxActionService',
	'pxEnvironmentService',
	'pxProgressService',
	'pxDisplayMessageService',
	'pxUploadService',
	'sbAclDatastore',
	'sbToastService',
	'sbContextMenuService',
	'sbActionRepository',
	'sbDesktopService',
	'sbMediaService',
	'sbPromptDialog',
	'sbaShareDialogService',
	'sbaToolbarService',
	'sbaLibraryDataStore',
	'sbaFolderDataStore',
	'sbaRecentDocumentsDataStore',
	'sbaFavoritesDataStore',
	'sbaSelectionDataStore',
	'sbaDocumentDataStore',
	'sbaInProgressItemsDataStore',
	'sbaDownloadDataStore',
	'sbaRenameDialog',
	'sbaCreateTaskDialog',
	'sbaMoveItemDialog',
	'SB_CHAR_LIMIT',
	'SBA_GET_REQUEST_RIGHTS_ENABLED',
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/folderView/folderView.ts